import PropTypes from 'prop-types';
import React from 'react';
import { duplicationText } from '../../../constants/initiativeDuplication.js';
import CheckIcon from '../../icons/CheckIcon.jsx';
import { CloseIcon } from '../../icons/CloseIcon.jsx';
import styles from '../../projectDuplications/DuplicationToasts.module.css';

/**
 * Success message after an initiative is duplicated (rendered by InitiativeCopyWatcher).
 * Without `targetProjectName` the copy is in the same project ("Open");
 * with it, the copy went to another project ("Open in <project>").
 */
const InitiativeDuplicationToast = ({
  title,
  targetProjectName,
  onOpen,
  onClose,
}) => (
  <div className={styles.stack}>
    <div role="status" className={`${styles.toast} ${styles.success}`}>
      <span className={styles.icon}>
        <CheckIcon />
      </span>
      <div className={styles.content}>
        <strong className={styles.title}>
          {duplicationText('successTitle')}
        </strong>
        <p className={styles.body}>
          {targetProjectName
            ? duplicationText('successBodyOtherProject', {
                title,
                target: targetProjectName,
              })
            : duplicationText('successBody', { title })}
        </p>
        <button
          type="button"
          className={`btn-clear bg-transparent text-primary ${styles.link}`}
          onClick={onOpen}
        >
          {targetProjectName
            ? duplicationText('openInProject', { target: targetProjectName })
            : duplicationText('open')}
        </button>
      </div>
      <button
        type="button"
        className={`btn-clear bg-transparent ${styles.close}`}
        onClick={onClose}
        aria-label="Close"
      >
        <CloseIcon />
      </button>
    </div>
  </div>
);

InitiativeDuplicationToast.propTypes = {
  title: PropTypes.string.isRequired,
  targetProjectName: PropTypes.string,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

InitiativeDuplicationToast.defaultProps = {
  targetProjectName: null,
};

export default InitiativeDuplicationToast;
